import {PropertyCache} from "../../../../stem-core/data-structures/PropertyCache";
import {StoreObject} from "../../../../stem-core/state/Store.js";
import {toArray} from "../../../../stem-core/base/Utils";

// TODO @branch Should not inherit StoreObject
// Every subclass implements these over its own resource; merged in rather than declared as
// fields so a subclass can define them as ordinary methods.
export interface BaseEditorState {
    load(...args: any[]): void;
    update(options: any, dispatch?: boolean): void;
    isEdited(): boolean;
    saveChanges(...args: any[]): any;
}

export class BaseEditorState extends StoreObject {
    // Set by instantiate(); the page that redraws when the state changes
    declare rootElement?: {redraw(): void};
    declare advancedMode?: boolean;
    // The subclass's working copy, and the "show the raw JSON" settings beside it
    declare value?: any;
    declare dashboardOptions?: Record<string, any>;

    // Set when a save fails, and rendered beside the form
    declare error?: any;

    static instanceCache = new PropertyCache("editorState"); // TODO @branch not sure if it's safe to share with children?

    static instantiate(resource: object, rootElement: {redraw(): void}) {
        const obj = this.instanceCache.get(resource, () => new this(resource)); // Getter must be here, since we're only used in inheritors
        obj.rootElement = rootElement;
        return obj;
    }

    dispatchChange() {
        this.dispatch("change", this);
    }

    setAdvancedMode(advancedMode: boolean) {
        this.advancedMode = advancedMode;
        this.dispatchChange();
        this.rootElement?.redraw();
    }

    discardChanges() {
        this.load();
        this.dispatchChange();
        this.rootElement?.redraw();
    }
}

// TODO Put in more common code here, and use entryOptions and dashboardOptions
export class SDKResourceEditorState extends BaseEditorState {
    getLabels() {
        return toArray(this.dashboardOptions?.labels);
    }

    editDashboardOptions(options: Record<string, any>) {
        Object.assign(this.dashboardOptions, options);
        for (const key of Array.from(Object.keys(this.dashboardOptions))) {
            if (this.dashboardOptions[key] === undefined) {
                delete this.dashboardOptions[key];
            }
        }
        this.dispatchChange();
    }
}